// extracted by mini-css-extract-plugin
export default {"toolbarDepartmentManagement":"tableView_toolbarDepartmentManagement__E-X-h"};